import { render } from "./PurchaseReportPage.vue?vue&type=template&id=8bf960d2&scoped=true&ts=true"
import script from "./PurchaseReportPage.vue?vue&type=script&lang=ts"
export * from "./PurchaseReportPage.vue?vue&type=script&lang=ts"

import "./PurchaseReportPage.vue?vue&type=style&index=0&id=8bf960d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf960d2"]])

export default __exports__